import { IOCoords } from 'pages/special/OrienteeringPage/OConfig';
import styled from 'styled-components/macro';

interface Props {
    activeCoordinate: number;
    onActiveCoordinateChange: (activeCoordinate: number) => void;
    coordinates: IOCoords[];
    onCoordinatesChange: (coordinates: IOCoords[]) => void;
    onComputeCorners: () => void;
    className?: string;
}

export const OActiveTable = (props: Props): JSX.Element => {
    const coordinates = props.coordinates;

    return (
        <S_OActiveTable className={props.className}>
            <S_Coordinate>Active: {props.activeCoordinate}</S_Coordinate>
            {coordinates.map((c, index) => {
                return (
                    <S_Coordinate
                        key={c.lat + c.lng}
                        onClick={() => {
                            props.onActiveCoordinateChange(index);
                        }}
                    >
                        {index}: {c.lat?.toFixed(3)}, {c.lng?.toFixed(3)} - {c.xPercent?.toFixed(3)}
                        , {c.yPercent?.toFixed(3)}
                        <span
                            onClick={(e) => {
                                e.stopPropagation();
                                const newCoordinates = [...coordinates];
                                newCoordinates.splice(index, 1);
                                props.onCoordinatesChange(newCoordinates);
                            }}
                        >
                            Delete
                        </span>
                    </S_Coordinate>
                );
            })}
            <S_Coordinate>
                <span
                    onClick={() => {
                        props.onActiveCoordinateChange(coordinates.length);
                        props.onCoordinatesChange([
                            ...coordinates,
                            {
                                lat: null,
                                lng: null,
                                xPercent: null,
                                yPercent: null,
                                hiddenLat: null,
                                hiddenLng: null
                            }
                        ]);
                    }}
                >
                    Add new coordinate
                </span>
            </S_Coordinate>
            <S_Coordinate>
                <span onClick={props.onComputeCorners}>Compute corners</span>
            </S_Coordinate>
        </S_OActiveTable>
    );
};

const S_OActiveTable = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    display: flex;
    flex-direction: column;
    background-color: grey;
    z-index: 100;
`;

const S_Coordinate = styled.div`
    display: flex;
`;
